export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hier"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aujourd'hui"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lundi"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mardi"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mercredi"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jeudi"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vendredi"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Samedi"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dimanche"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["janvier"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["février"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mars"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["avril"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mai"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["juin"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["juillet"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["août"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["septembre"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["octobre"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["novembre"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["décembre"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vous"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrateur"])}
}